import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { trackCta } from "@/lib/trackCta";
import { SocialFeed } from "@/components/SocialFeed";

export const ContentHub = () => {
  return (
    <section className="py-24 bg-background">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16 animate-fade-in">
          <h2 className="font-display text-4xl md:text-5xl font-bold text-foreground mb-4">
            Recent
          </h2>
          <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
            No scripts. No formulas. Just what's true.
          </p>
        </div>

        <div className="max-w-5xl mx-auto mb-12 animate-slide-up">
          <div className="relative aspect-video rounded-2xl overflow-hidden shadow-bold">
            <iframe
              src="https://www.youtube.com/embed/DHlgKeP3yvo"
              title="Rob Lasa - Latest"
              className="absolute inset-0 w-full h-full"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
        </div>

        <div className="text-center space-y-6 mb-20">
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button 
              size="lg"
              asChild
              variant="outline"
              className="gap-2"
            >
              <Link to="/journal" onClick={() => trackCta("home_content_journal", "/journal", "See More")}>
                See More
              </Link>
            </Button>
          </div>
        </div>

        <SocialFeed />
      </div>
    </section>
  );
};
